<template>
  <ul class="lg-aa-layout__conteudo__sidebar__container__menu">
    <li
      v-for="produto in produtos"
      :key="produto.sigla"
      :class="menuStyle(produto.sigla)"
      @click.stop="irParaProduto(produto)"
    >
      <a>
        <i :class="produto.icone" />
        <span>{{ produto.nome }}</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'LGPanelProduto',
  props: {
    produtos: {
      type: Array,
      required: true,
    },
  },
  computed: {
    layoutEmPreview() {
      return this.$store.state.layout.preview;
    },
    produtoAtivo() {
      return this.$lg.config.produto;
    },
  },
  methods: {
    menuStyle(sigla) {
      return {
        'lg-aa-layout__conteudo__sidebar__container__menu__item--produto-ativo': sigla === this.produtoAtivo,
      };
    },
    irParaProduto(produto) {
      if (produto.sigla !== this.produtoAtivo && !this.layoutEmPreview) {
        const acaoCustomizada = this.$store.getters['layout/getAcaoCustomizada'](produto.sigla);

        if (acaoCustomizada) {
          acaoCustomizada.call(this, produto);
        } else if (produto.url) {
          if (produto.abrirNovaAba) {
            window.open(produto.url);
          } else {
            window.location = produto.url;
          }
        }
      }
    },
  },
};
</script>
